import { DateTime } from 'luxon';

const isValidISODate = isoDate => {
  return DateTime.fromISO(isoDate).isValid;
};

export default isValidISODate;
